(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-image-zoom"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('hoc-product-zoom')) return;
    customElements.define('hoc-product-zoom', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.section = this.closest('[data-product-section]');
        this.dialog = this.querySelector('dialog');
        this.trigger = this.section.querySelector('[data-zoom-open]');
        if (!this.trigger || !this.dialog.showModal) return;
        this.images = JSON.parse(this.querySelector('[data-zoom-images]').textContent);
        this.image = this.querySelector('[data-zoom-image]');
        this.stage = this.querySelector('[data-zoom-stage]');
        this.counter = this.querySelector('[data-zoom-count]');
        this.error = this.querySelector('[data-zoom-error]');
        this.controller = new AbortController();
        this.pointers = new Map();
        const on = (node, event, fn) => node.addEventListener(event, fn, { signal: this.controller.signal });
        on(this.trigger, 'click', event => { event.preventDefault(); this.open(); });
        on(this.trigger, 'keydown', event => { if (event.key === ' ') { event.preventDefault(); this.open(); } });
        on(this.querySelector('[data-zoom-close]'), 'click', () => this.dialog.close());
        on(this.dialog, 'close', () => this.cleanup());
        on(this.querySelector('[data-zoom-in]'), 'click', () => this.zoom(this.scale + .5));
        on(this.querySelector('[data-zoom-out]'), 'click', () => this.zoom(this.scale - .5));
        on(this.querySelector('[data-zoom-reset]'), 'click', () => this.zoom(1));
        on(this.querySelector('[data-zoom-prev]'), 'click', () => this.show(this.index - 1));
        on(this.querySelector('[data-zoom-next]'), 'click', () => this.show(this.index + 1));
        on(this.dialog, 'keydown', event => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
          if (event.key === '+' || event.key === '=') { event.preventDefault(); this.zoom(this.scale + .5); }
          if (event.key === '-') { event.preventDefault(); this.zoom(this.scale - .5); }
        });
        on(this.image, 'load', () => { this.image.hidden = false; this.error.hidden = true; });
        on(this.image, 'error', () => { this.image.hidden = true; this.error.hidden = false; });
        on(this.stage, 'dblclick', event => { event.preventDefault(); this.zoom(this.scale > 1 ? 1 : 2.5); });
        on(this.stage, 'pointerdown', event => {
          if (event.button !== 0) return;
          this.stage.setPointerCapture(event.pointerId);
          this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          this.gesture();
        });
        on(this.stage, 'pointermove', event => {
          if (!this.pointers.has(event.pointerId)) return;
          this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          const points = [...this.pointers.values()];
          if (points.length > 1) {
            const rect = this.stage.getBoundingClientRect();
            const x = (points[0].x + points[1].x) / 2 - rect.left - rect.width / 2;
            const y = (points[0].y + points[1].y) / 2 - rect.top - rect.height / 2;
            this.scale = Math.min(4, Math.max(1, this.startScale * Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y) / this.distance));
            this.x = x - this.anchorX * this.scale;
            this.y = y - this.anchorY * this.scale;
          } else if (this.scale > 1) {
            this.x += points[0].x - this.lastX;
            this.y += points[0].y - this.lastY;
            this.lastX = points[0].x;
            this.lastY = points[0].y;
          }
          this.render();
        });
        const release = event => { this.pointers.delete(event.pointerId); this.gesture(); };
        on(this.stage, 'pointerup', release);
        on(this.stage, 'pointercancel', release);
        on(this.stage, 'lostpointercapture', release);
        this.resize = new ResizeObserver(() => { if (this.dialog.open) this.fit(); });
        this.resize.observe(this.stage);
      }
      open() {
        if (this.dialog.open || !this.images.length) return;
        const selected = this.section.querySelector('#ProductMainImage');
        const id = selected?.getAttribute('data-image-id');
        const index = this.images.findIndex(image => String(image.id) === id);
        this.returnFocus = document.activeElement;
        this.overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.show(index < 0 ? 0 : index);
      }
      show(index) {
        this.index = (index + this.images.length) % this.images.length;
        const item = this.images[this.index];
        this.scale = 1; this.x = 0; this.y = 0;
        this.pointers.clear();
        this.stage.classList.remove('is-dragging');
        this.image.hidden = false; this.error.hidden = true;
        this.image.alt = item.alt;
        this.image.width = item.width; this.image.height = item.height;
        this.image.src = item.src;
        this.counter.textContent = this.counter.dataset.label.replace('[current]', this.index + 1).replace('[total]', this.images.length);
        this.fit();
      }
      fit() {
        const item = this.images[this.index];
        if (!item) return;
        const fit = Math.min((this.stage.clientWidth - 24) / item.width, (this.stage.clientHeight - 16) / item.height);
        this.width = item.width * Math.max(0, fit);
        this.height = item.height * Math.max(0, fit);
        this.image.style.width = this.width + 'px';
        this.image.style.height = this.height + 'px';
        this.render();
      }
      zoom(scale) {
        const next = Math.min(4, Math.max(1, scale));
        this.x *= next / this.scale;
        this.y *= next / this.scale;
        this.scale = next;
        this.render();
      }
      render() {
        const boundX = Math.max(0, (this.width * this.scale - this.stage.clientWidth) / 2);
        const boundY = Math.max(0, (this.height * this.scale - this.stage.clientHeight) / 2);
        this.x = Math.max(-boundX, Math.min(boundX, this.x));
        this.y = Math.max(-boundY, Math.min(boundY, this.y));
        this.image.style.transform = `translate(${this.x}px, ${this.y}px) scale(${this.scale})`;
        this.stage.classList.toggle('is-zoomed', this.scale > 1);
        this.querySelector('[data-zoom-reset]').textContent = Math.round(this.scale * 100) + ' %';
        this.querySelector('[data-zoom-out]').disabled = this.scale <= 1;
        this.querySelector('[data-zoom-in]').disabled = this.scale >= 4;
      }
      gesture() {
        const points = [...this.pointers.values()];
        this.stage.classList.toggle('is-dragging', points.length > 0 && this.scale > 1);
        if (points.length > 1) {
          const rect = this.stage.getBoundingClientRect();
          this.distance = Math.max(1, Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y));
          this.startScale = this.scale;
          this.anchorX = ((points[0].x + points[1].x) / 2 - rect.left - rect.width / 2 - this.x) / this.scale;
          this.anchorY = ((points[0].y + points[1].y) / 2 - rect.top - rect.height / 2 - this.y) / this.scale;
        } else if (points.length === 1) { this.lastX = points[0].x; this.lastY = points[0].y; }
      }
      cleanup() {
        if (this.overflow === undefined) return;
        document.body.style.overflow = this.overflow;
        this.overflow = undefined;
        this.pointers.clear();
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.cleanup();
        this.controller?.abort();
        this.resize?.disconnect();
        this.controller = null;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
